import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { formatDollars, TWO_DECIMAL_DIGITS } from '../../../utils/formatting';
import s from './EarningsDisplay.scss';

interface Props {
  /**
   * Our user's estimated earnings. This should be the value after we've calculated it.
   */
  earnings: number;

  /**
   * Displayed after the `earnings`. We usually pass an icon with a tooltip here.
   */
  postfix: React.ReactNode;
  className?: string;
}

/**
 * The bulk of our earnings calculator's display. Contains a slot for a {@link Props.postfix|postfix}.
 */
const EarningsDisplay: React.FC<Props> = ({ earnings, postfix, className }) => {
  const { t } = useTranslation();
  return (
    <div className={c(s['root'], className)}>
      <span className={s['label']}>{t('estimatedEarnings.label')}</span>
      <span className={s['earnings']}>{formatDollars(earnings, TWO_DECIMAL_DIGITS)}</span>
      {postfix}
    </div>
  );
};

EarningsDisplay.displayName = 'EarningsDisplay';

export default EarningsDisplay;
